// frontend/src/components/AdminSettings.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE, UPLOADS_BASE } from '../apiConfig';
import '../css/AdminBlog.css';

function AdminSettings({ embedded = false }) {
  const [siteName, setSiteName] = useState('');
  const [logo, setLogo] = useState(null);
  const [icon, setIcon] = useState(null);
  const [preview, setPreview] = useState({ logo: '', icon: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // 🔐 الباسورد وتسجيل الدخول
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const correctPassword = 'admin123'; // غيّرها لو تحب

  // ✅ تحقق من localStorage عند بداية الصفحة
  useEffect(() => {
    if (embedded) {
      setIsAuthenticated(true);
      return;
    }
    const auth = localStorage.getItem('admin-authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, [embedded]);

  // ⬇️ تحميل الإعدادات
  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    axios
      .get(`${API_BASE}/settings`)
      .then(res => {
        setSiteName(res.data.site_name);
        setPreview({
          logo: `${UPLOADS_BASE}/${res.data.logo}`,
          icon: `${UPLOADS_BASE}/${res.data.icon}`
        });
      })
      .catch(err => {
        console.error('Error fetching settings:', err.message);
        setError('Failed to load settings.');
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated]);

  // ⬇️ التحديث
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const formData = new FormData();
    formData.append('site_name', siteName);
    if (logo) formData.append('logo', logo);
    if (icon) formData.append('icon', icon);

    try {
      await axios.post(`${API_BASE}/settings`, formData);
      alert('Updated successfully!');
      if (logo || icon) {
        setPreview({
          logo: logo ? URL.createObjectURL(logo) : preview.logo,
          icon: icon ? URL.createObjectURL(icon) : preview.icon,
        });
      }
    } catch (error) {
      console.error('Update failed:', error.message);
      setError('Update failed.');
    } finally {
      setLoading(false);
    }
  };

  // 🔓 تسجيل الخروج (اختياري)
  const handleLogout = () => {
    if (embedded) return;
    localStorage.removeItem('admin-authenticated');
    setIsAuthenticated(false);
    setPassword('');
  };

  // ⛔️ لو لسه مدخلش الباسورد
  if (!isAuthenticated) {
    return (
      <div className="admin-blog-container py-5">
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card admin-form-card shadow">
              <div className="card-header bg-dark text-white">
                <h4 className="mb-0">🔒 Admin Access</h4>
              </div>
              <div className="card-body">
                <input
                  type="password"
                  className="form-control mb-3"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    if (password === correctPassword) {
                      localStorage.setItem('admin-authenticated', 'true');
                      setIsAuthenticated(true);
                    } else {
                      alert('Incorrect password');
                    }
                  }}
                >
                  Enter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ✅ الصفحة الأصلية بعد تسجيل الدخول
  return (
    <div className="admin-blog-container">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="card admin-form-card mb-4">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h2 className="header-title mb-0">Admin Settings</h2>
              <button className="btn btn-sm btn-outline-danger" onClick={handleLogout}>
                Logout
              </button>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-danger">{error}</div>}
                {loading && <div className="alert alert-info py-2">Processing...</div>}
                <div className="form-group mb-3">
                  <label className="form-label">Site Name</label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    value={siteName}
                    onChange={(e) => setSiteName(e.target.value)}
                    placeholder="Enter site name..."
                    required
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="form-label">Logo</label>
                  <input
                    type="file"
                    className="form-control custom-file-input"
                    onChange={(e) => setLogo(e.target.files[0])}
                  />
                  {preview.logo && (
                    <div style={{ marginTop: 10 }}>
                      <img src={preview.logo} alt="Logo" height="50" style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} />
                    </div>
                  )}
                </div>
                <div className="form-group mb-4">
                  <label className="form-label">Icon</label>
                  <input
                    type="file"
                    className="form-control custom-file-input"
                    onChange={(e) => setIcon(e.target.files[0])}
                  />
                  {preview.icon && (
                    <div style={{ marginTop: 10 }}>
                      <img src={preview.icon} alt="Icon" height="32" style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} />
                    </div>
                  )}
                </div>
                <button type="submit" className="btn custom-btn btn-create w-100" disabled={loading}>
                  Update
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSettings;
